module.exports = __webpack_public_path__ + "assets/img/dctwo.c75b39de.png";